// Clamp a single dragged element's new position so it stays within its bounds
// (the poster, or a parent container). coy = contentOffsetY: text renders its glyphs
// above the box origin, so the box may sit up to coy above the top edge.

import type { Position, Dimensions, Box } from '../../types'

export function clampDragPos(
	startBox: Box,
	dx: number, dy: number,
	bounds: Dimensions,
	coy: number,
): Position {
	return {
		x: Math.max(0,    Math.min(startBox.pos.x + dx, bounds.width  - startBox.dims.width)),
		y: Math.max(-coy, Math.min(startBox.pos.y + dy, bounds.height - startBox.dims.height - coy)),
	}
}

// Clamp a box's origin on one axis so the box sits inside [0, parent] (accounting for a content
// offset for text, whose glyphs can render up to `offset` above the box origin). When the box is
// larger than the parent it can't fit, so it is pulled flush to the nearest edge instead — the
// [lo,hi] interval simply inverts, and the clamp still resolves to the closest reachable edge.
// Deterministic in its inputs, so it can never ping-pong: used to pull off-bounds objects back
// inside their parent when rendering a poster in user mode (see effectiveBox overrides).
export function clampAxisIntoParent(pos: number, size: number, parent: number, offset = 0): number {
	const a  = -offset                // top/left-flush (visible content at 0)
	const b  = parent - size - offset // bottom/right-flush
	const lo = Math.min(a, b)
	const hi = Math.max(a, b)
	const c  = Math.min(Math.max(pos, lo), hi)
	if (c === pos) return pos         // in-bounds values pass through unrounded (rounding here shifted centred hug boxes off their design position)
	const r  = Math.round(c)
	return r === 0 ? 0 : r            // normalise -0 (from a zero-offset flush) to +0
}
